import { type FC, type MouseEventHandler } from 'react';
import { Button } from '@mantine/core';
import { useAskProofsPayinOrder } from '~/entities/payin';

interface AskProofsProps {
    id: string;
    disabled?: boolean;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

export const AskProofs: FC<AskProofsProps> = ({ id, disabled, onSuccess, onError }) => {
    const { mutate, isPending } = useAskProofsPayinOrder({ onSuccess, onError });

    const handleConfirm: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        mutate({
            orderId: {
                value: id,
            },
        });
    };

    return (
        <Button
            title='Запросить подтверждение перевода'
            loading={isPending}
            onClick={handleConfirm}
            disabled={isPending || disabled}
        >
            Запросить подтверждение перевода
        </Button>
    );
};
